// ----------------------------------------------------------------------
import "./fonts/fonts.css";

const PRIMARY_FONT = "Inter, sans-serif";
const SECONDARY_FONT = "InterDisplay, sans-serif";
const TIEMPOS = "TiemposText, sans-serif";
const TIEMPOS_HEAD = "TiemposHeadline, sans-serif";

const typography = {
  fontFamily: PRIMARY_FONT,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  interDisplay400: {
    fontFamily: SECONDARY_FONT,
    fontWeight: 400,
  },
  interDisplay500: {
    fontFamily: SECONDARY_FONT,
    fontWeight: 500,
  },
  interDisplay600: {
    fontFamily: SECONDARY_FONT,
    fontWeight: 600,
  },
  interDisplay800: {
    fontFamily: SECONDARY_FONT,
    fontWeight: 800,
  },
  inter400: {
    fontFamily: PRIMARY_FONT,
    fontWeight: 400,
  },
  inter500: {
    fontFamily: PRIMARY_FONT,
    fontWeight: 500,
  },
  inter600: {
    fontFamily: PRIMARY_FONT,
    fontWeight: 600,
  },
  inter800: {
    fontFamily: PRIMARY_FONT,
    fontWeight: 800,
  },
  tiempos400: {
    fontFamily: TIEMPOS,
    fontWeight: 400,
  },
  tiempos500: {
    fontFamily: TIEMPOS,
    fontWeight: 500,
  },
  tiempos600: {
    fontFamily: TIEMPOS,
    fontWeight: 600,
  },
  tiemposHead400: {
    fontFamily: TIEMPOS_HEAD,
    fontWeight: 400,
  },
  tiemposHead500: {
    fontFamily: TIEMPOS_HEAD,
    fontWeight: 500,
  },
  tiemposHead600: {
    fontFamily: TIEMPOS_HEAD,
    fontWeight: 600,
  },
} as const;

export default typography;
